import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d94a24f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "病院の一覧", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("病院の追加")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "apply" }
const _hoisted_5 = { class: "horizontal" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "プロフィール", -1))
const _hoisted_13 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_badge = _resolveComponent("n-badge")!
  const _component_HospitalData = _resolveComponent("HospitalData")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu),
          _hoisted_1,
          _createVNode(_component_n_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/hospital/add')))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_n_space, {
                key: 0,
                vertical: "",
                style: {"background-color":"white","padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "33%"
                  }),
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hospitals.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hospitals, (a) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: a.id
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(a.name), 1),
                        (a.stripeCustomer === 'invoice6')
                          ? (_openBlock(), _createBlock(_component_n_badge, {
                              key: 0,
                              value: "請求書払い",
                              class: "badge pointer",
                              color: "#1b3dad",
                              onClick: ($event: any) => (_ctx.invoice(a.id))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      (a.status === 'waitReview')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.changeLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "…"))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.changeStatus(a.id, 'approved'))
                                  }, "認可", 8, _hoisted_9),
                                  _hoisted_10,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.changeStatus(a.id, 'rejected'))
                                  }, "拒否", 8, _hoisted_11)
                                ]))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("details", null, [
                        _hoisted_12,
                        _createVNode(_component_HospitalData, { data: a }, null, 8, ["data"])
                      ])
                    ]),
                    _createVNode(_component_n_divider, { class: "noMargin" })
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_n_empty, { description: "登録された求職者はいません" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}